import React from 'react'
import PropTypes from 'prop-types'
import styled from 'styled-components'
import { TableCell, TableRow } from '@material-ui/core'
import { theme } from '../../theme/Global'

const MessageWrapper = styled.div`
  color: ${theme.colors.text};
  display: flex;
  justify-content: center;
  align-items: center;
  font-size: 14px;
  height: calc(100vh - 344px);
  border-bottom: none;
`

const TableCellWrapper = styled(TableCell)`
  border-bottom: none;
`

const EmptyTableMessage = ({ text, columns }) => {
  return (
    <TableRow>
      <TableCellWrapper colSpan={columns}>
        <MessageWrapper>
          {text}
        </MessageWrapper>
      </TableCellWrapper>
    </TableRow>
  )
}

EmptyTableMessage.propTypes = {
  text: PropTypes.string,
  columns: PropTypes.number
}

export default EmptyTableMessage
